<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title"></h4>
    </div>
    <div v-if="selectedBetgame" class="card-content">
      <form>

        <div class="row">
          <div class="col-md-6">
            <h5 style="margin-top: 0px">Tippabgabe-Modus</h5>
            <div>
            <input v-if="bet_mode === 1" v-model="bet_mode" style="margin-left: 10px;" type="radio" id="bm_1" name="bet_mode" value="1" checked>
            <input v-else v-model="bet_mode" style="margin-left: 10px;" type="radio" id="1" name="bet_mode" value="1">
            <label for="1">Ergebnis</label>
            </div>
            <div>
            <input v-if="bet_mode === 2" v-model="bet_mode" style="margin-left: 10px;" type="radio" id="bm_2" name="bet_mode" value="2" checked>
            <input v-else v-model="bet_mode" style="margin-left: 10px;" type="radio" id="2" name="bet_mode" value="2">
            <label for="2">Dreier-Wette (1-0-2)</label>
            </div>
          </div>
        </div>

        <div v-if="isTournament(this.$store.state.competition)" class="row" style="margin-top: 20px;">
          <div class="col-md-6">
            <h5 style="margin-top: 0px">Ergebnis nach</h5>
            <div>
              <input v-if="result_mode === 3" v-model="result_mode" style="margin-left: 10px;" type="radio" id="rm_3" name="result_mode" value="3" checked>
              <input v-else v-model="result_mode" style="margin-left: 10px;" type="radio" id="3" name="result_mode" value="3">
              <label for="1">90 Minuten</label>
            </div>
            <div>
              <input v-if="result_mode === 2" v-model="result_mode" style="margin-left: 10px;" type="radio" id="rm_2" name="result_mode" value="2" checked>
              <input v-else v-model="result_mode" style="margin-left: 10px;" type="radio" id="2" name="result_mode" value="2">
              <label for="2">120 Minuten</label>
            </div>
            <div>
              <input v-if="result_mode === 1" v-model="result_mode" style="margin-left: 10px;" type="radio" id="rm_1" name="result_mode" value="1" checked>
              <input v-else v-model="result_mode" style="margin-left: 10px;" type="radio" id="1" name="result_mode" value="1">
              <label for="2">Elfmeterschiessen</label>
            </div>
          </div>
        </div>

        <div class="row" style="margin-top: 20px;">
          <div class="col-md-3">
            <h5>Punkte-Vergabe</h5>
          </div>
        </div>
        <div v-if="parseInt(bet_mode) === 1" class="row" style="margin-top: 5px;">
          <div class="col-md-3">
            <fg-input
                      label="Exaktes Ergebnis"
                      v-model="points_bet_result">
            </fg-input>
          </div>
        </div>
        <div v-else-if="parseInt(bet_mode) === 2" class="row" style="margin-top: 5px;">
          <div class="col-md-3">
            <fg-input
              label="Punkte pro richtigem Tipp"
              v-model="points_bet_result">
            </fg-input>
          </div>
        </div>

        <div v-if="parseInt(bet_mode) === 1" class="row">
          <div class="col-md-3">
            <fg-input type="text"
                      label="Tordifferenz"
                      v-model="points_bet_goaldiff">
            </fg-input>
          </div>
        </div>

        <div v-if="parseInt(bet_mode) === 1" class="row">
          <div class="col-md-3">
            <fg-input type="text"
                      label="Tendenz"
                      v-model="points_bet_tendency">
            </fg-input>
          </div>
        </div>

        <div v-if="parseInt(bet_mode) === 1 && !isTournament(this.$store.state.competition)" class="row" style="margin-top: 40px;">
          <div class="col-md-12">
            <h5 style="width: 100%;">Sortierung bei Punktgleichheit</h5>
            <div>
              <input v-if="sort_mode === 1" v-model="sort_mode" style="margin-left: 10px;" type="radio" id="1" name="sort_mode" value="1" checked>
              <input v-else v-model="sort_mode" style="margin-left: 10px;" type="radio" id="1" name="sort_mode" value="1">
              <label for="1">1. Gesamtpunkte, 2. Spieltagssiege, 3. Exakte Tipps, 4. Tordifferenz</label>
            </div>
            <div>
              <input v-if="sort_mode === 2" v-model="sort_mode" style="margin-left: 10px;" type="radio" id="2" name="sort_mode" value="2" checked>
              <input v-else v-model="sort_mode" style="margin-left: 10px;" type="radio" id="2" name="sort_mode" value="2">
              <label for="2">1. Gesamtpunkte, 2. Exakte Tipps, 3. Spieltagssiege, 4. Tordifferenz</label>
            </div>
          </div>
        </div>
        <div v-else-if="parseInt(bet_mode) === 1 && isTournament(this.$store.state.competition)" class="row" style="margin-top: 40px;">
          <div class="col-md-12">
            <h5 style="width: 100%;">Sortierung bei Punktgleichheit</h5>
            <div>
              <input v-if="sort_mode === 1" v-model="sort_mode" style="margin-left: 10px;" type="radio" id="1" name="sort_mode" value="1" checked>
              <input v-else v-model="sort_mode" style="margin-left: 10px;" type="radio" id="1" name="sort_mode" value="1">
              <label for="1">1. Gesamtpunkte, 2. Exakte Tipps, 3. Tordifferenz</label>
            </div>
          </div>
        </div>
        <div v-if="parseInt(bet_mode) === 2 && !isTournament(this.$store.state.competition)" class="row" style="margin-top: 40px;">
          <div class="col-md-12">
            <h5 style="width: 100%;">Sortierung bei Punktgleichheit</h5>
            <div>
              <input v-if="sort_mode === 1" v-model="sort_mode" style="margin-left: 10px;" type="radio" id="1" name="sort_mode" value="1" checked>
              <input v-else v-model="sort_mode" style="margin-left: 10px;" type="radio" id="1" name="sort_mode" value="1">
              <label for="1">1. Gesamtpunkte, 2. Spieltagssiege</label>
            </div>
          </div>
        </div>
        <div v-if="parseInt(bet_mode) === 2 && isTournament(this.$store.state.competition)" class="row" style="margin-top: 40px;">
          <div class="col-md-12">
            <h5 style="width: 100%;">Sortierung bei Punktgleichheit</h5>
            <div>
              <input v-if="sort_mode === 1" v-model="sort_mode" style="margin-left: 10px;" type="radio" id="1" name="sort_mode" value="1" checked>
              <input v-else v-model="sort_mode" style="margin-left: 10px;" type="radio" id="1" name="sort_mode" value="1">
              <label for="1">1. Gesamtpunkte</label>
            </div>
          </div>
        </div>

        <div class="text-right" style="margin-top: 30px; margin-bottom: 30px;">
          <button type="submit" class="btn btn-info btn-fill btn-wd" @click.prevent="updateBetgame">
            Speichern
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        selectedBetgame: {},
        points_bet_result: '3',
        points_bet_goaldiff: '2',
        points_bet_tendency: '1',
        bet_mode: 1,
        result_mode: 1,
        sort_mode: 1
      }
    },
    created () {
      if (!this.$store.state.betgameData) {
        this.$store.dispatch('fetchBetgame', this.$store.state.betgame)
      }
    },
    mounted () {
      this.selectedBetgame = this.$store.state.betgameData
      if (this.selectedBetgame) {
        this.points_bet_result = '' + this.selectedBetgame.points_bet_result
        this.points_bet_goaldiff = '' + this.selectedBetgame.points_bet_goaldiff
        this.points_bet_tendency = '' + this.selectedBetgame.points_bet_tendency
        this.bet_mode = this.selectedBetgame.bet_mode
        this.sort_mode = this.selectedBetgame.sort_mode
        this.result_mode = this.selectedBetgame.result_mode
      }
    },
    methods: {
      isTournament (competition) {
        const tournments = [19, 33, 107, 139, 533, 541, 999, 1110, 1180]
        return tournments.includes(parseInt(competition))
      },
      betModeChanged (event) {
      },
      save (file) {
        this.$store.dispatch('uploadBetgameIcon', file)
          .then(() => {
          })
          .catch(err => {
            this.$log.debug(err)
          })
      },
      filesChange (fieldName, fileList) {
        if (!fileList.length) return
        let file = fileList[0]
        let fileSizeinMB = file.size / 1024 / 1024
        if (fileSizeinMB < 10) {
          this.save(file)
        }
      },
      uploadButtonClicked () {
        document.getElementById('imageFileInput').click()
      },
      buildIconPath (icon, width) {
        return window.sessionStorage.getItem('bgbackend_apiUrl') + '/icons/' + width + '/' + icon
      },
      updateBetgame () {
        // alert('' + JSON.stringify(this.selectedBetgame))
        this.$store.dispatch('patchBetgame', {
          points_bet_result: parseInt(this.points_bet_result),
          points_bet_goaldiff: parseInt(this.points_bet_goaldiff),
          points_bet_tendency: parseInt(this.points_bet_tendency),
          sort_mode: parseInt(this.sort_mode),
          bet_mode: parseInt(this.bet_mode),
          result_mode: parseInt(this.result_mode)
        })
          .then(() => {
            if (this.selectedBetgame) {
              this.selectedBetgame.points_bet_result = parseInt(this.points_bet_result)
              this.selectedBetgame.points_bet_goaldiff = parseInt(this.points_bet_goaldiff)
              this.selectedBetgame.points_bet_tendency = parseInt(this.points_bet_tendency)
              this.selectedBetgame.sort_mode = parseInt(this.sort_mode)
              this.selectedBetgame.bet_mode = parseInt(this.bet_mode)
              this.selectedBetgame.result_mode = parseInt(this.result_mode)
            }
            alert('Tippspiel-Daten wurden aktualisiert')
          })
          .catch(function (error) {
            this.$log.debug(error)
          })
          .finally(function () {
          })
      }
    },
    computed: {
      betgameId () {
        return '' + this.selectedBetgame.id
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/BGEditSettingsForm.vue